<template>
  <div id="smart-padding" ref="smartPadding">
    <!-- 其他内容 -->
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ucooStatusBarHeight } from '../utils/ucoowebview' // 确保路径正确

const smartPadding = ref(null) // 使用 ref 访问 DOM 元素

onMounted(() => {
  // 确保组件已经挂载
  if (smartPadding.value) {
    ucooStatusBarHeight(height => {
      console.log('status bar height: ' + height)

      // 确保 height 是一个有效的数字
      let padNum = parseInt(height, 10)
      if (isNaN(padNum)) {
        padNum = 0 // 或者根据需求设置默认值
        console.warn('解析 height 失败，设置为 0')
      }

      // 设置高度
      smartPadding.value.style.height = padNum / 3.75 + 'vw'
    })
  } else {
    console.error('无法找到 #smart-padding 元素')
  }
})
</script>

<style scoped>
#smart-padding {
  /* 初始高度可以设置为 0 或其他合适的值 */
  height: 0;
  /* 其他样式 */
}
</style>
